import { call, put, takeEvery, select, delay } from "redux-saga/effects";
import { message } from "antd";
import * as executorCardActions from "../actions/executorCard";

import { getExecutorByIdRequest } from "../../api/executorCard/getExecutorByIdRequest";
import { createExecutorRequest } from "../../api/executorCard/createExecutorRequest";
import { updateExecutorRequest } from "../../api/executorCard/updateExecutorRequest";
import { deleteExecutorRequest } from "../../api/executorCard/deleteExecutorRequest";
import { restoreArchiveExecutorRequest } from "../../api/executorCard/restoreArchiveExecutorRequest";

import history from "../../../../common/history";
import { errorProcessing } from "../../../Employees/api/errorProcessing";
import showSuccessWindow from "../../../../common/components/successPopup/successPopup";
import {
  // todo
  successCreateExecutor,
  successDeleteExecutor,
  successUpdateExecutor,
  successRestoreArchiveExecutor
} from "../../components/ExecutorCard/popup/success";
import { SYSTEM_SETTINGS } from "../../../../common/constants/systemUrls";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* createExecutorSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        createExecutorRequest,
        activeProfileId,
        action.payload
      );
      if (response.status === 200) {
        yield put(executorCardActions.createExecutorSuccess(response));
        showSuccessWindow(successCreateExecutor(response.companyName));
        history.push("/" + SYSTEM_SETTINGS + "/executors");
      }
    } catch (err) {
      let errData = errorProcessing(err);
      message.error(errData.message);
      yield put(executorCardActions.createExecutorError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* updateExecutorSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateExecutorRequest,
        activeProfileId,
        action.payload
      );
      yield put(executorCardActions.updateExecutorSuccess(response));
      showSuccessWindow(successUpdateExecutor(response.companyName));
      history.push("/" + SYSTEM_SETTINGS + "/executors");
    } catch (err) {
      let errData = errorProcessing(err);
      message.error(errData.message);
      yield put(executorCardActions.updateExecutorError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* deleteExecutorSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        deleteExecutorRequest,
        activeProfileId,
        action.payload
      );
      showSuccessWindow(successDeleteExecutor(response.companyName));
      yield put(executorCardActions.deleteExecutorSuccess(response));
      history.push("/" + SYSTEM_SETTINGS + "/executors");
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(executorCardActions.deleteExecutorError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* restoreArchiveExecutorSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        restoreArchiveExecutorRequest,
        activeProfileId,
        action.payload
      );
      showSuccessWindow(successRestoreArchiveExecutor(response.companyName));
      yield put(executorCardActions.restoreArchiveExecutorSuccess(response));
      history.push("/" + SYSTEM_SETTINGS + "/executors");
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(executorCardActions.restoreArchiveExecutorError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* getExecutorByIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      let { payload } = action;
      const response = yield call(
        getExecutorByIdRequest,
        activeProfileId,
        payload
      );
      yield put(executorCardActions.getExecutorByIdSuccess(response));
    } catch (e) {
      const errData = errorProcessing(e);
      message.error(errData.message);
      yield put(executorCardActions.getExecutorByIdFailure(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(executorCardActions.getExecutorById(action.payload))
      : history.push("/authorization/profiles");
  }
}

export function* executorCardWatcher() {
  yield takeEvery(
    executorCardActions.getExecutorById.toString(),
    getExecutorByIdSaga
  );
  yield takeEvery(
    executorCardActions.createExecutor.toString(),
    createExecutorSaga
  );
  yield takeEvery(
    executorCardActions.updateExecutor.toString(),
    updateExecutorSaga
  );
  yield takeEvery(
    executorCardActions.deleteExecutor.toString(),
    deleteExecutorSaga
  );
  yield takeEvery(
    executorCardActions.restoreArchiveExecutor.toString(),
    restoreArchiveExecutorSaga
  );
}
